export default [
    {
        "id": "wishlist-details",
        "html": require('./wishlist-details/html').default
    }
]